import { Main } from "../../components/utilities";
import MissingAccountsModal from "./components/MissingAccountsModal";
import TransactionExceptions from "./components/TransactionExceptions";
import TransactionPotentialMatchesGrid from "./components/TransactionPotentialMatchesGrid";
import CustodianTransactionMatchingProvider from "./hooks/CustodianTransactionMatchingContext";

const CustodianTransactionMatching = () => {

    return (
        <CustodianTransactionMatchingProvider>
            <Main className="d-flex flex-column p-2">
                <TransactionExceptions />
                <TransactionPotentialMatchesGrid />
            </Main>
            <MissingAccountsModal />
        </CustodianTransactionMatchingProvider>
    );
};

export default CustodianTransactionMatching;